var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon15(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 18.5,
    fill: "white",
    stroke: "#21A6E9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_726_53)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.9546 9.02102C20.4603 9.05224 19.9796 9.18458 19.5353 9.44094C18.3506 10.1246 17.7892 11.473 17.7385 12.9077C17.6877 14.3425 18.1105 15.9399 18.9868 17.4569C19.8631 18.9739 21.0386 20.1444 22.3071 20.8179C23.5757 21.4913 25.0222 21.674 26.2069 20.9904C27.3916 20.3068 27.9514 18.9665 28.0021 17.5318C28.0529 16.097 27.6317 14.4914 26.7554 12.9745C25.8791 11.4575 24.702 10.2951 23.4335 9.62161C22.6406 9.20071 21.7785 8.969 20.9546 9.02102ZM22.5415 12.9533C22.7114 12.9658 22.8764 12.994 23.0363 13.0379C23.6758 13.2135 24.2191 13.6249 24.5256 14.1643C25.1385 15.243 24.8488 16.8642 23.4725 17.6636C23.2816 17.7742 23.0547 17.8046 22.8414 17.7482C22.6282 17.6918 22.446 17.5531 22.3348 17.3625C22.2242 17.1716 22.1938 16.9447 22.2502 16.7314C22.3067 16.5181 22.4454 16.336 22.6359 16.2248C23.3493 15.8105 23.292 15.3604 23.0803 14.9878C22.8686 14.6152 22.5409 14.345 21.7993 14.773C21.7044 14.8275 21.5997 14.8628 21.4912 14.8768C21.3827 14.8908 21.2724 14.8834 21.1668 14.8548C21.0611 14.8262 20.9621 14.7771 20.8755 14.7103C20.7888 14.6435 20.7161 14.5603 20.6616 14.4654C20.551 14.2745 20.5206 14.0475 20.577 13.8343C20.6335 13.621 20.7722 13.4388 20.9627 13.3277C21.485 13.0263 22.0318 12.9157 22.5415 12.9533Z",
    fill: "#21A6E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7388 12.6392L12.9156 17.369C12.6989 17.6372 12.6698 18.0112 12.8423 18.3097L15.1796 22.3511C15.3514 22.6485 15.688 22.81 16.0275 22.758L22.0383 21.8156C20.5838 20.9993 19.2398 19.6417 18.2297 17.8931C17.2191 16.1437 16.7183 14.3064 16.7388 12.6392Z",
    fill: "#21A6E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3478 17.0673C13.2283 17.0794 13.1129 17.1172 13.0095 17.1781L11.9698 17.7748C10.0044 18.909 9.56401 21.0061 10.395 22.4193C11.2261 23.8325 13.2572 24.4864 15.1994 23.3728C15.2015 23.3728 15.2036 23.3728 15.2057 23.3728L16.2453 22.7699C16.436 22.6588 16.5748 22.4766 16.6314 22.2632C16.6879 22.0498 16.6574 21.8228 16.5467 21.6319L14.1477 17.4795C14.0678 17.3415 13.9499 17.2293 13.8082 17.1563C13.6664 17.0832 13.5065 17.0522 13.3478 17.0673Z",
    fill: "#21A6E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3952 22.9583C17.3038 23.1252 17.1688 23.2641 17.0045 23.3603L15.6943 24.1204H15.6846C14.5222 24.7869 13.3397 24.9378 12.3008 24.7356L13.9984 27.6799C14.0026 27.686 14.007 27.6919 14.0114 27.6978C14.6797 28.7781 16.2161 29.4144 17.6035 28.6516C17.61 28.6495 17.6165 28.6474 17.623 28.6451C18.8819 27.9186 19.3152 26.2872 18.5882 25.0286L17.3952 22.9583Z",
    fill: "#21A6E9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_726_53"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(9 9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon15);
export default __webpack_public_path__ + "static/media/icon15.0a095c99c5e65630a09ab0960dd8d3f0.svg";
export { ForwardRef as ReactComponent };